<template>
  <v-snackbar
    :value="enabled"
    @input="onClose"
    timeout="6000"
  >
    {{ text }}
    <template v-slot:action="{ attrs }">
        <v-btn
        dark
        text
        v-bind="attrs"
        @click="onClick()"
      >
        {{ button }}
      </v-btn>
    </template>
  </v-snackbar>
</template>
<script>
  export default {
    name: 'Snackbar',

    props: {
      show: {
        type: Boolean,
        default: false,
      },
      text: {
        type: String,
        default: '',
      },
      routeTo: {
        type: String,
        default: '',
      },
      button: {
        type: String,
        default: 'OK',
      }
    },
    model: {
        prop: 'show',
        event: 'showchange'
    },
    data () {
      return {
      }
    },
    computed: {
      enabled: {
        get: function() {
          return this.show
        },
        set: function(value) {
          this.$emit('onClose', value)
        }
      }
    },
    methods: {
      onClick () {
        if(this.routeTo) {
          this.$router.push(this.routeTo)
        } else {
          this.enabled = false;
        }
      },
      onClose () {
        this.enabled = false;
      }
    }
  }
</script>

<style lang="sass">
  .v-snackbar--material
    margin-top: 32px
    margin-bottom: 32px

    .v-alert--material,
    .v-snack__wrapper
      border-radius: 4px

    .v-snack__content
      overflow: visible
      padding: 0
</style>
